export default __webpack_public_path__ + "static/media/a011-fsi-06.2cfcbe22.svg";